import react, { useEffect, useState } from 'react';
import OrderDetailItemNew from '../OrderDetailItem/index copy';
import styled from 'styled-components';








export default function OrderDetailsContainerNew({ orderReleaseList = [], orderNumber = "" }) {
  const [orderDetails, setOrderDetails] = useState([]);

  useEffect(() => {
    if (orderReleaseList.length > 0) {
      setOrderDetails(orderReleaseList);
    }
  }, [orderReleaseList]);


  const OrderDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-family: 'Ancizar Sans', sans-serif;
    margin-top: 1rem;
    width: 100%;
  `
  return (
   <OrderDetailsContainer>
        {orderDetails.length > 0 && orderDetails.map((orderItem, index) => (
            <OrderDetailItemNew
            key={index}
            orderItemDetails={orderItem}
            orderNumber={orderNumber}
            />
        ))}
   </OrderDetailsContainer>
  );
}